/** @file ClipListEmpty: a puppet with no clips: the A-pose note and "Import template clips…". */
import type { ReactElement } from 'react';
import { useState } from 'react';
import { useEditor } from '../../state/useEditor';

/** Only while the puppet has no clips. The import button runs the store's `importTemplateClips` once (disabled while it runs, or without a puppet or a server). */
export function ClipListEmpty(): ReactElement | null {
  const none = useEditor((s) => Object.keys(s.puppet.doc?.clips ?? {}).length === 0);
  const puppet = useEditor((s) => s.puppet.id);
  const action = useEditor((s) => s.importTemplateClips);
  const [busy, setBusy] = useState(false);
  const off = busy || puppet === null || action === undefined;
  const run = (): void => {
    if (off) return;
    setBusy(true);
    void action().finally(() => { setBusy(false); });
  };
  if (!none) return null;
  return (
    <div data-empty="clips" style={{ padding: '8px 10px', color: 'var(--muted, #8b919e)', lineHeight: 1.4 }}>
      <p style={{ margin: '0 0 8px' }}>No clips yet. The rig stands in its A-pose.</p>
      <button type="button" disabled={off} onClick={run} style={{ font: 'inherit', fontSize: 11, padding: '2px 6px' }}
        title={action === undefined ? 'Needs the server' : 'Every standard clip of the template; clips the puppet has are kept'}>
        {busy ? 'Importing…' : 'Import template clips…'}
      </button>
    </div>
  );
}
